import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { trackError } from 'utils/helpers';
import EcomComponentWrapper from 'components/ecom_component_wrapper';

export const NewsletterSubscribe = ({
  handleChange,
  veroSubscribeTitle = 'Subscribe to our newsletter',
  veroSubscribeText = 'Stay up to date with information on special offers and events.',
  veroActionUrl,
  veroBusinessUnitTag,
  veroSuccessRedirectUrl,
  veroFailureRedirectUrl,
  ...props
}) => {
  if (
    veroActionUrl &&
    veroBusinessUnitTag &&
    veroSuccessRedirectUrl &&
    veroFailureRedirectUrl
  ) {
    const formData = {
      [`user[${veroBusinessUnitTag}]`]: true,
      [`user[${veroBusinessUnitTag}_subscribed]`]: true,
    };

    const onSubmit = (values, { setSubmitting, isSubmitting }) => {
      if (isSubmitting) {
        return;
      }

      setSubmitting(true);

      const params = {
        ...formData,
        ...values,
        'user[state]': values.userLocation,
      };

      fetch(veroActionUrl, {
        method: 'POST',
        body: new URLSearchParams(params),
      })
        .then((response) => {
          const redirect =
            response.status === 200
              ? veroSuccessRedirectUrl
              : veroFailureRedirectUrl;

          // https://stackoverflow.com/a/11384018
          window.open(redirect, '_blank').focus();
        })
        .catch((error) => {
          trackError(error);
          setSubmitting(false);
        });
    };

    return (
      <EcomComponentWrapper>
        <div>
          <div className="ecom-component__title h4 mb-2">
            {veroSubscribeTitle}
          </div>
          <p>{veroSubscribeText}</p>
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            userFullName: props.userFullName ? props.userFullName : '',
            userEmail: props.userEmail ? props.userEmail : '',
            userLocation: '',
          }}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="row g-2 mb-3 mb-md-0">
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <label className="mb-2" htmlFor="userFullName">
                    Your full name{' '}
                    <sup className="text-xx-small text-danger">*</sup>
                  </label>
                  <Field
                    name="userFullName"
                    id="userFullName"
                    className="form-control"
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <label className="mb-2" htmlFor="userEmail">
                    Your email address{' '}
                    <sup className="text-xx-small text-danger">*</sup>
                  </label>
                  <Field
                    type="email"
                    name="userEmail"
                    id="userEmail"
                    className="form-control"
                    placeholder="Your email address"
                    required
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label className="mb-2" htmlFor="userLocation">
                    Your location{' '}
                    <sup className="text-xx-small text-danger">*</sup>
                  </label>
                  <Field
                    as="select"
                    name="userLocation"
                    id="userLocation"
                    className="form-select"
                    required
                  >
                    <option disabled value="">
                      Location
                    </option>
                    <option value="act">ACT</option>
                    <option value="nsw">NSW</option>
                    <option value="nt">NT</option>
                    <option value="qld">QLD</option>
                    <option value="sa">SA</option>
                    <option value="tas">TAS</option>
                    <option value="vic">VIC</option>
                    <option value="wa">WA</option>
                    <option value="international">International</option>
                  </Field>
                </div>
              </div>
              <div className="row mt-sm-3">
                <div className="col">
                  <button
                    type="submit"
                    className="btn btn-secondary btn-block"
                    disabled={isSubmitting}
                  >
                    Subscribe
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <div className="mt-3 text-body-secondary text-x-small">
          1-click unsubscribe at anytime
        </div>
      </EcomComponentWrapper>
    );
  }
  return null;
};

NewsletterSubscribe.propTypes = {
  handleChange: PropTypes.func,
  userEmail: PropTypes.string,
  userFullName: PropTypes.string,
  veroSubscribeTitle: PropTypes.string,
  veroSubscribeText: PropTypes.string,
  veroActionUrl: PropTypes.string.isRequired,
  veroBusinessUnitTag: PropTypes.string.isRequired,
  veroSuccessRedirectUrl: PropTypes.string.isRequired,
  veroFailureRedirectUrl: PropTypes.string.isRequired,
};

export default NewsletterSubscribe;
